export const CHANNEL_META = {
  booking_com: { label: "Booking.com", color: "#003580" },
  airbnb: { label: "Airbnb", color: "#FF5A5F" },
  expedia: { label: "Expedia", color: "#FBCC33" },
  direct: { label: "Direktno", color: "#11A285" },
  booking_engine: { label: "Booking engine", color: "#FF990A" },
  walk_in: { label: "Walk-in", color: "#64748B" },
  phone: { label: "Telefon", color: "#8B5CF6" },
};
export const channelLabel = (c) => CHANNEL_META[c]?.label || c;
export const channelColor = (c, i = 0) => CHANNEL_META[c]?.color || ["#0EA5E9", "#A855F7", "#F43F5E", "#84CC16"][i % 4];

export const eur = (v, digits = 0) =>
  new Intl.NumberFormat("hr-HR", { style: "currency", currency: "EUR", maximumFractionDigits: digits, minimumFractionDigits: digits }).format(v || 0);
export const num = (v, digits = 0) => new Intl.NumberFormat("hr-HR", { maximumFractionDigits: digits, minimumFractionDigits: digits }).format(v || 0);

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const PRESETS = [
  { id: "this_month", label: "Ovaj mjesec" },
  { id: "last_month", label: "Prošli mjesec" },
  { id: "next_30", label: "Idućih 30 dana" },
  { id: "last_30", label: "Zadnjih 30 dana" },
  { id: "this_year", label: "Ova godina" },
  { id: "last_year", label: "Prošla godina" },
  { id: "custom", label: "Vlastito" },
];

export function presetRange(id) {
  const t = new Date();
  const y = t.getFullYear();
  const m = t.getMonth();
  const add = (days) => new Date(y, m, t.getDate() + days);
  switch (id) {
    case "last_month": return [iso(new Date(y, m - 1, 1)), iso(new Date(y, m, 0))];
    case "next_30": return [iso(t), iso(add(29))];
    case "last_30": return [iso(add(-29)), iso(t)];
    case "this_year": return [iso(new Date(y, 0, 1)), iso(new Date(y, 11, 31))];
    case "last_year": return [iso(new Date(y - 1, 0, 1)), iso(new Date(y - 1, 11, 31))];
    default: return [iso(new Date(y, m, 1)), iso(new Date(y, m + 1, 0))];
  }
}

const MONTHS = ["sij", "velj", "ožu", "tra", "svi", "lip", "srp", "kol", "ruj", "lis", "stu", "pro"];
export function bucketLabel(key, gran) {
  if (gran === "month") {
    const [yy, mm] = key.split("-");
    return `${MONTHS[Number(mm) - 1]} ${yy.slice(2)}`;
  }
  const [, mm, dd] = key.split("-");
  return `${Number(dd)}.${Number(mm)}.`;
}

export function downloadCsv(filename, rows, columns) {
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const lines = [columns.map((c) => esc(c.label)).join(";"), ...rows.map((r) => columns.map((c) => esc(c.csv ? c.csv(r) : r[c.key])).join(";"))];
  const blob = new Blob(["\ufeff" + lines.join("\n")], { type: "text/csv;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}
